import React, { useState } from 'react';
import { UploadDocumentsBox } from '@/components/common/InputBoxes';
import { Container } from '@/ui/layout';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { Button } from '@/components/common/atoms';

export const UploadFilesModal = ({ onSubmit, multiple = false, ...props }) => {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  return (
    <Modal {...props}>
      <UploadDocumentsBox
        label={t('Upload file')}
        docs={files}
        setDocs={(files) =>
          Array.isArray(files) ? setFiles(files) : setFiles(files ? [files] : [])
        }
        multiple={multiple}
      />

      <Container $marginTop={20} style={{ textAlign: 'center' }}>
        <Button text={t('Save')} onClick={() => onSubmit(files)} type={'primary'} />
      </Container>
    </Modal>
  );
};
